module.exports = __webpack_public_path__ + "img/wmv.833a228e.svg";